import { MessageBarType } from '@fluentui/react';
import { IDefaultSorting, IDisplayColumn } from '../interfaces/ManageView';
import CopyLink from '../components/molecules/HeaderComponents/DuplicateView';
import { MeetingType } from 'src/Models/MeetingType';
import { SolutionArea } from 'src/Models/SolutionArea';
import { FinancialYear } from 'src/Models/FinancialYear';
import { DeliveryBlockers, GPS_AskType } from 'src/Models/DropdownFields';
import { Priority } from 'src/Models/Priority';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { Clause } from '../interfaces/ViewFolderRequest';
import { ISupportedOperation } from '../interfaces/Slice.types';

export class ManageViewConstants {
  public static ExportLimit: number = 1500;
  public static MarketPlace_ExportLimit: number = 2000;
  public static ROB_ExportLimit_Excel: number = 2500;
  public static ROB_ExportLimit_PPT_DOC: number = 10;
  public static ROB_ExportLimit_PPT_APR_IAR: number = 50;
  public static ROB_ExportLimit_Word: number = 10;

  public static UrlQueryParameters = {
    ViewId: 'viewID',
    TenantId: 'tenantId',
    ViewIdArtemis: 'queryId',
    IsShared: 'isShared',
  };

  public static ReadonlyCode = 'readonly';

  public static HeaderContextmenu = {
    MakeAsDefaultView: 'Mark as Default',
    ExportActions: 'Download Results',
    EmailActions: 'Email Results',
    Delete: 'Delete View',
    DeleteFolder: 'Delete Folder',
    CopyLinkToShare: 'Copy Link to Share',
    ApplyView: 'Apply View',
    ApplyViewConfirmTitle: 'Apply View?',
    ApplyViewDescription: 'This view will become your new default view.',
    ApplyViewConfirmButton: 'Apply',
    ApplyViewCancelButton: 'Cancel',
  };

  public static DefaultPropsValue = {
    ViewName: 'Assigned to me',
    EditIconName: 'edit',
    UpdateIconName: 'CheckMark',
  };

  public static HeaderIcon = {
    Favorite: 'Favorite',
    FavoriteIcon: 'FavoriteStar',
    Unfavorite: 'Unfavorite',
    UnfavoriteIcon: 'FavoriteStarFill',
    DuplicateThisView: 'Clone view',
    CopyLinkToShareIcon: 'Link12',
    CustomFavoriteStartIcon: 'CustomFavoriteStartIcon',
    CustomUnfavoriteStartIcon: 'CustomUnfavoriteStartIcon',
    MoreVertical: 'MoreVertical',
    More: 'More',
    Copy: 'Copy',
  };
  public static ViewFolderDialog = {
    Name: 'Name',
    SelectParentFolder: 'Select parent folder',
    EnterViewName: 'Enter view name',
    EnterFolderName: 'Enter folder name',
    NoParentFolder: 'No parent folder',
    ChevronDown: 'ChevronDown',
    ChevronUp: 'ChevronUp',
    ChevronRight: 'ChevronRight',
    FolderHorizontal: 'FolderHorizontal',
  };

  public static RatingContext = {
    ManageViews: 'ManageViews',
    ManageViewsLabel: 'Manage Views',
  };

  public static Dialog = {
    NO: 'No',
    YES: 'Yes',
  };

  public static deleteViewDialog = {
    deleteViewTitle: 'Delete View',
    deleteFolderTitle: 'Delete Folder',
  };

  public static DisplayMessages = {
    ErrorMessages: {
      GenericMessage: 'Something went wrong. Please contact Support Team.',
    },
    SuccessMessages: {
      ViewCopySuccess: 'View copied successfully!',
      ViewSaveSuccess: 'The view has been successfully saved.',
      ViewDeleted: 'View deleted successfully.',
      FolderDeleted: 'Folder deleted successfully.',
      ViewCreated: 'View created successfully.',
      FolderCreated: 'Folder created successfully.',
      ViewUpdated: 'View updated successfully.',
    },
  };

  public static Views = {
    AssignedToMe: 'Assigned To Me',
    AssignedToOrg: 'Assigned To Organization',
    AllActions: 'All Actions',
    SystemViews: 'System Views',
    MyViews: 'My Views',
    AddNew: '+ Add New',
    SharedWithMe: 'Shared With Me',
    RequestedByMe: 'Requested by Me',
  };

  public static FilterQuery = {
    SelectTags: 'Select Tags',
    ClickToAdd: 'Click to Add',
    Select: 'Select',
    AreaPathCustom: 'areaPathCustom',
  };

  public static AddButton = {
    NewView: 'New view',
    NewFolder: 'New folder',
    Cancel: 'Cancel',
    Create: 'Create',
  };

  public static ApiProblemDetailsCodes = {
    UserAlreadyAddedToSharedView: 'User already exists',
  };

  public static Timing = {
    MessageBarDisplayTime: 5000,
  };

  public static resolveDelay = 300;

  public static CompareFieldOperators: string[] = [
    '= [Field]',
    '<> [Field]',
    '> [Field]',
    '< [Field]',
    '>= [Field]',
    '<= [Field]',
  ];

  public static GroupOperators: string[] = ['In Group', 'Not In Group'];

  public static MultiselectOperators: string[] = ['In', 'Not In'];

  public static MicrosoftFederalAreaPath = 'Microsoft Federal';

  public static PickListwithAnyFields: string[] = ['workItemType'];

  public static ErrorMessages = {
    nameIsRequired: 'Name is required and should be unique',
    nameLengthExceeded: 'Name should not exceed 50 characters',
    itemAlreadyExists: 'An item already exists',
  };

  public static DataSanitizeMessages = {
    toShow: true,
    message: `Modified text to ensure security`,
    messageType: MessageBarType.warning,
    styleClass: '',
    timeout: 20000,
  };

  public static atParam = '@Param';
  public static mailOperatorKeywordADOQuery = '<<mail:';
  public static groupOperatorKeywordADOQuery = '<<group:';
  public static Project = import.meta.env.VITE_PROJECT || 'Unified Action Tracker Test';
  public static IsProduction = ManageViewConstants.Project === 'Unified Action Tracker';

  public static AssignToCorp = ManageViewConstants.IsProduction
    ? 'Custom.AssignToCorp'
    : 'Custom.AssigntoCorp';

  public static StateNames = {
    InTechnicalFeedback: 'In Technical Feedback',
  };

  public static ManageviewFields = {
    FiscalYearArtemis: 'fields/fy',
    MonthArtemis: 'fields/month',
    QuarterArtemis: 'fields/quarter',
    AreaPathArtemis: 'fields/areapath',
    WorkItemTypeArtemis: 'fields/workitemtype',
    StateArtemis: 'fields/state',
    SubStateArtemis: 'fields/substate',
    MeetingTypeArtemis: 'fields/meetingtypelist',
    MeetingSubTypeArtemis: 'fields/meetingsubtypelist',
    RegionsArtemis: 'fields/regions',
    SubRegionsArtemis: 'fields/subregions',
    AreasArtemis: 'fields/areas',
    ActionOwnerGroupArtemis: 'fields/actionownergroup',
    ActionPriorityFieldArtemis: 'fields/actionpriorityfield',
    SolutionAreaUATArtemis: 'fields/solutionareauat',
    //SolutionAreaArtemis: 'fields/solutionarea',
    ProblemTypeArtemis: 'fields/problemtype',
    CategoryArtemis: 'fields/actioncategoryfield',
    FinancialYearArtemis: 'fields/financialyear',
    AreaArtemis: 'fields/area',
    EOUArtemis: 'fields/eou',
    PMYT_AreasArtemis: 'fields/pmyt_areas',
    PMYT_IndustriesArtemis: 'fields/pmyt_industries',
    PMYT_CustomerSegmentArtemis: 'fields/pmyt_customersegment',
    PMYT_PartnerTypeArtemis: 'fields/pmyt_partnertype',
    PMYT_SolutionPlaysArtemis: 'fields/pmyt_solutionplays',
    PMYT_SourceOfInvestmentArtemis: 'fields/pmyt_sourceofinvestment',
    PMYT_SolutionArea: 'fields/pmyt_solutionarea',
    GPSSurveyUrgencyArtemis: 'fields/gps_surveyurgency',
    GPSSurveyTypeArtemis: 'fields/gps_surveytype',
    GPSSurveyAudienceArtemis: 'fields/gps_surveyaudience',
    GPSLocalizedContentLibraryArtemis: 'fields/gps_isalreadyexistsinlocalizedcontentlibrary',
    AdditionalAreaArtemis: 'fields/additionalarea',
    AdditionalEOUArtemis: 'fields/additionaleou',
    DeliveryBlockersArtemis: 'fields/deliveryblockers',
    PriorityArtemis: 'fields/priority',
    ImpactTypeArtemis: 'fields/impacttype',
    TagsArtemis: 'tags/name',
    SolutionAreaArtemis: 'raidrelations/msxaccounts/accounts/opportunities/solutionarealist',
    Id: 'System.Id',
    AdditionalTheme: 'Custom.AdditionalTheme',
    AdditionalArea: 'Custom.AdditionalArea',
    AdditionaEOU: 'Custom.AdditionalEOU',
    ListeningCircleArea: 'Custom.ListeningCircleArea',
    Tags: 'System.Tags',
    AssigntoCorp: ManageViewConstants.IsProduction ? 'Custom.AssignToCorp' : 'Custom.AssigntoCorp',
    AssigntoCorpProd: 'Custom.AssignToCorp',
    AreaPath: 'System.AreaPath',
    DeliveryBlockers: 'Custom.DeliveryBlockers',
    SolutionArea: 'Custom.SolutionArea',
    State: 'System.State',
    AreaField: 'Custom.AreaField',
    MilestoneStatus: 'Custom.MilestoneStatus',
    SubState: 'Custom.SubState',
    CSGProducts: 'Custom.CSGProducts',
    Status: 'Custom.Status',
    IntenttomovetoCloud: 'Custom.IntenttomovetoCloud',
    InterestedinotherECIF: 'Custom.InterestedinotherECIF',
    ifNoStateReason: 'Custom.Cloudintentreason',
    ECIFReason: 'Custom.ECIFReason',
    Program: 'Custom.NewProgram',
    Application: 'Custom.Application',
    ECIFStatus: 'Custom.ECIFStatus',
    ECIFrequestedservicestatus: 'Custom.ECIFrequestedservicestatus',
    InterestedinAssessment: 'Custom.InterestedinAssessment',
    AssessmentType: 'Custom.AssessmentType',
    MigrationType: 'Custom.MigrationType',
    Partner: 'Custom.Partner',
    ECIFstatusifCMA: 'Custom.ECIFstatusifCMA',
    InterestedinrenewingBREPorSA: 'Custom.InterestedinrenewingBREPorSA',
    AssessmentStatus: 'Custom.AssessmentStatus',
    ScopeValue: 'Custom.Scope',
    FY: 'Custom.FY',
    Quarter: 'Custom.Quarter',
    QBCTop5Ask: 'Custom.QBCTop5Ask',
    AzurePriority: 'Custom.AzurePriority',
    TopicCategory: 'Custom.TopicCategory',
    Organization: 'Custom.Org',
    TriageValue: 'Microsoft.VSTS.Common.Triage',
    EngContactvalue: 'Custom.EngineeringContacts',
    EngStatusValue: 'Custom.Engineeringstatus',
    ActionCategoryField: 'Custom.ActionCategoryField',
    ActionPriorityField: 'Custom.ActionPriorityField',
    EOU: 'Custom.EOU',
    Industry: 'Custom.Industry',
    customIndustry: 'Custom.CustomIndustry',
    PatternGroupName: 'Custom.PatternGroup',
    MilestoneReason: 'Custom.MilestoneReason',
    MilestoneWorkload: 'Custom.MilestoneWorkload',
    HelpNeededField: 'Custom.HelpNeededField',
    TestSuitType: 'Microsoft.VSTS.TCM.TestSuiteType',
    AutomationStatus: 'Microsoft.VSTS.TCM.AutomationStatus',
    StateCode: 'Microsoft.VSTS.Common.StateCode',
    ClosedStatus: 'Microsoft.VSTS.CodeReview.ClosedStatus',
    ClosedStatusCode: 'Microsoft.VSTS.CodeReview.ClosedStatusCode',
    IsBlocked: 'Custom.IsBlocked',
    OneListFeedback: 'Custom.OneListFeedback',
    FeatureParityRequest: 'Custom.FeatureParityRequest',
    Priority: 'Microsoft.VSTS.Common.Priority',
    Rating: 'Microsoft.VSTS.Common.Rating',
    Severity: 'Microsoft.VSTS.Common.Severity',
    SyncWithCE: 'Custom.SyncWithCE',
    WorkItemType: 'System.WorkItemType',
    BoardColumn: 'System.BoardColumn',
    BoardColumnDone: 'System.BoardColumnDone',
    ValueArea: 'Microsoft.VSTS.Common.ValueArea',
    NonRecurring: 'Custom.NonRecurring',
    CloudIntentreason: 'Custom.CloudIntentreason',
    Completionstatusifcombined: 'Custom.Completionstatusifcombined',
    Escalated: 'Custom.Escalated',
    MeetingTypeOrigin: 'Custom.MeetingTypeOrigin',
    MeetingSubType: 'Custom.MeetingSubType',
    Nonrenewingreason: 'Custom.Nonrenewingreason',
    PubliclyDocumented: 'Custom.PubliclyDocumented',
    WorkloadType: 'Custom.WorkloadType',
    Issue: 'Microsoft.VSTS.Common.Issue',
    Activity: 'Microsoft.VSTS.Common.Activity',
    FoundIn: 'Microsoft.VSTS.Build.FoundIn',
    IntegrationBuild: 'Microsoft.VSTS.Build.IntegrationBuild',
    Blocked: 'Microsoft.VSTS.CMMI.Blocked',
    Reason: 'System.Reason',
    IsCovid19: 'Custom.IsCovid19',
    IsitFAM: 'Custom.IsitFAM',
    IterationPath: 'System.IterationPath',
    Theme: 'Custom.Theme',
    CAEEngagementCategory: 'Custom.CAEEngagementCategory',
    CAEEngagementRegion: 'Custom.AzureRegion',
    CAEScenarioCohort: 'Custom.CAEScenarioCohort',
    CAEFirstPartyOffering: 'Custom.OfferingName_MultiSelect',
    CAEFirstPartySolution: 'Custom.AZServiceName',
    CAEThirdPartySolution: 'Custom.CAEThirdPartySolution',
    LTEscalation: 'Custom.LTEscalation',
    AssociatedContextType: 'Microsoft.VSTS.CodeReview.ContextType',
    MeetingsPitchDeck: 'Custom.MeetingsPitchDeck',
    TCOAnalysis: 'Custom.TCOAnalysis',
    POCECIFConsumption: 'Custom.POCECIFConsumption',
    SubmittedforAWR: 'Custom.SubmittedforAWR',
    ActionType: 'Custom.ActionType',
    InterestedinAssistedMigration: 'Custom.InterestedinAssistedMigration',
    ServiceTreeOffering: 'Custom.ServiceTreeOfferingName',
    ServiceTreeOffering2: 'Custom.ServiceTreeOfferingName2',
    ServiceTreeOffering3: 'Custom.ServiceTreeOfferingName3',
    BusinessProposal: 'Custom.BusinessProposal',
    ECIFstatusforFAM: 'Custom.ECIFstatusforFAM',
    ApplicationType: 'Microsoft.VSTS.Feedback.ApplicationType',
    OfferRelated: 'Custom.OfferRelated',
    SolutionAreaList: 'Custom.SolutionAreaUAT',
    HelpNeededOpportunity: 'Custom.HelpNeededOpportunity',
    OpportunityStatus: 'Custom.Opportunity_Outcome',
    OpportunityIntent: 'Custom.OpportunityIntent',
    ProjectName: 'Custom.ProjectName',
    SOObjective: 'Custom.SOObjective',
    OperatingUnitList: 'Custom.OperatingUnit',
    CloudImpactedList: 'Custom.CloudImpacted',
    ReferredTo: 'Custom.ReferredTo',
    HelpNeededApex: 'Custom.HelpNeededApex',
    WhenDoesCustomerWantToEngage: 'Custom.CustomerEngagementTimeLine',
    PartOfCollabAppsContent: 'Custom.PartofCollabAppsContest',
    ITandBusinessStakeholders: 'Custom.ITandBusinessstakeholders',
    ExecutiveSponsor: 'Custom.ExecutiveSponsor',
    BusinessDivision: 'Custom.BusinessDivision',
    RolesImpacted: 'Custom.RolesImpacted',
    ToolsImpacted: 'Custom.ToolsImpacted',
    IntakeType: 'Custom.Intake',
    ProblemType: 'Custom.ProblemType',
    StrategicCategory: 'Custom.StrategicCategory',
    L1BusinessProcess: 'Custom.BPAL1',
    L2BusinessProcess: 'Custom.BPAL2',
    L3BusinessProcess: 'Custom.BPAL3',
    ExecutingTeamName: 'Custom.ExecutingTeamName',
    RequestType: 'Custom.RequestType',
    ApexPartnerEngage: 'Custom.IsPartnerEngage',
    AOAI_Timezone: 'Custom.AOAI_Timezone',
    AOAIRequestedType: 'Custom.AOAI_RequestType',
    AOAIRequestedVMType: 'Custom.AOAI_RequestedVMType',
    AOAI_DealType: 'Custom.AOAI_DealType',
    AOAI_Model: 'Custom.AOAI_Model',
    AOAI_IsRecommendedForDWR: 'Custom.AOAI_IsRecommendedForDWR',
    AOAI_PreferredRegion: 'Custom.AOAI_PreferredRegionMultiselect',
    AOAI_Decision: 'Custom.AOAI_Decision',
    AOAIRequestUrgency: 'Custom.RequestUrgency',
    AOAIUOM: 'Custom.UnitofMeasurement',
    AOAI_ApprovedPrefferedRegion: 'Custom.AOAI_ApprovedPrefferedRegion',
    IsAmendemeentSigned: 'Custom.AOAI_IsAmendmentM1072Signed',
    NominationType: 'Custom.NominationType',
    RB_Area: 'Custom.RB_Area',
    RB_Region: 'Custom.RB_Region',
    RB_Country: 'Custom.RB_Country',
    RB_Technology: 'Custom.RB_Technology',
    RB_GeneralCategory: 'Custom.RB_GeneralCategory',
    RB_TicketReason: 'Custom.RB_TicketReason',
    RB_InfraLocation: 'Custom.RB_InfraLocation',
    ECIF_TypeofFunds: 'Custom.ECIF_TypeofFunds',
    ECIF_ProgramName: 'Custom.ECIFProgramName',
    ECIF_EntityType: 'Custom.ECIF_EntityType',
    ECIF_DeliveryMethod: 'Custom.ECIFDeliveryMethod',
    ECIF_IncrementalACR: 'Custom.ECIF_IncrementalACR',
    ECIF_SpendPlan: 'Custom.ECIF_SpendPlan',
    ECIF_SupplierSameAsCustomer: 'Custom.ECIFIssuppliersameascustomer',
    ECIF_TypeofActivity: 'Custom.ECIF_TypeofActivity',
    ECIF_ROIAttached: 'Custom.ECIF_ROIAttached',
    MaaS_RequestType: 'Custom.MaaS_Request_Type',
    MaaS_Role: 'Custom.MaaS_Role',
    MaaS_Marketer_Role: 'Custom.MaaS_Marketer_Role',
    MaaS_Seller_Role: 'Custom.MaaS_Seller_Role',
    MaaS_Area: 'Custom.MaaS_Area',
    MaaS_OU: 'Custom.MaaS_OU',
    MaaS_Industry: 'Custom.MaaS_Industry',
    MaaS_Segment: 'Custom.MaaS_Segment',
    MaaS_SubSegment: 'Custom.MaaS_SubSegment',
    MaaS_MCEM_Stage: 'Custom.MaaS_MCEM_Stage',
    MaaS_TechTargetexistingAccount: 'Custom.MaaS_TechTargetexistingAccount',
    MaaS_IsInterestedOrgChat: 'Custom.MaaS_IsInterestedOrgChat',
    MaaS_IsInterestedAccountProfile: 'Custom.MaaS_IsInterestedAccountProfile',
    MaaS_SpecificCountry: 'Custom.MaaS_SpecificCountry',
    MaaS_UpdateExistingAccount: 'Custom.MaaS_UpdateExistingAccount',
    FeedbackType: ManageViewConstants.IsProduction
      ? 'Custom.FeedbackType'
      : 'Custom.164269a5-6f7e-4335-8be1-8fd9781f47e2',
    AssistedMigrationReason: ManageViewConstants.IsProduction
      ? 'Custom.AssistedMigrationreason'
      : 'Custom.AssistedMigrationReason',
    MeetingsWorkshop: ManageViewConstants.IsProduction
      ? 'Custom.712cc8bd-2363-410f-a0d6-f3a30e9ed34c'
      : 'Custom.MeetingsWorkshop',

    //Missed fields
    Account: 'Custom.Account',
    AccountableExec: 'Custom.AccountableExec',
    ActiveSalesProcess: 'Custom.ActiveSalesProcess',
    ActiveSalesStage: 'Custom.ActiveSalesStage',
    AgreementId: 'Custom.AgreementId',
    AgreementName: 'Custom.AgreementName',
    Apac: 'Custom.APAC',
    BoardLane: 'System.BoardLane',
    DefaultEqualsMaxETA: 'Custom.DefaultequalsMaxETA',
    India: 'Custom.India',
    Data: 'Custom.Data',
    Archive: 'Custom.Archive',
    AskID: 'Custom.AskID',
    AssignToCorpDate: 'Custom.AssignToCorpDate',
    AzureCEState: 'Custom.AzureCEState',
    AzureCESubState: 'Custom.AzureCESubState',
    AzServiceName: 'Custom.AZServiceName',
    ServiceRegionavail: 'Custom.ServiceRegionAvailability',
    OfferingName: 'Custom.OfferingName',
    ClosureStatement: 'Custom.ClosureStatement',
    CSGTest: 'Custom.CSGTest',
    CompeteBlockerEscalation: 'Custom.CompeteBlockerEscalation',
    Competitor: 'Custom.CompetitorNameDD',
    Contributor1: 'Custom.Contributor1',
    Contributor2: 'Custom.Contributor2',
    ConversationID: 'Custom.ConversationID',
    CurrentUser: 'Custom.CurrentUser',
    CustomerImpactData: 'Custom.CustomerImpactData',
    CustomerScenarioandDesiredOutcome: 'Custom.CustomerScenarioandDesiredOutcome',
    CustomerCommitment: 'Custom.CustomerCommitment',
    DealSize: 'Custom.DealSize',
    DesiredOutcome: 'Custom.DesiredOutcome',
    DualUse: 'Custom.DualUse',
    ESE: 'Custom.ESE',
    MilestoneLink: 'Custom.MilestoneLink',
    OpportunityLink: 'Custom.OpportunityLink',
    EstimatedMonthlyUsage: 'Custom.EstimatedMonthlyUsage',
    EstMonthlyUsage: 'Custom.EstMonthlyUsage',
    ExitCriteria: 'Custom.ExitCriteria',
    FAQ: 'Custom.FAQ',
    FeedbackTypeValue: 'Custom.164269a5-6f7e-4335-8be1-8fd9781f47e2',
    FeedbackTitle: 'Custom.FeedbackTitle',
    FeedbackItemUrl: 'Custom.FeedbackItemUrl',
    FeedbackNumber: 'Custom.FeedbackNumber',
    ImpactSummary: 'Custom.ImpactSummary',
    InternalRolespecificNotes: 'Custom.InternalRolespecificNotes',
    IsPDMHelpNeeded: 'Custom.IsPDMHelpNeeded',
    Partners: 'Custom.Partners',
    PDM: 'Custom.PDM',
    PDMEmail: 'Custom.PDMEmail',
    LastEmailDate: 'Custom.LastEmailDate',
    LTExecDirect: 'Custom.LTExecDirect',
    LockUAT: 'Custom.LockUAT',
    Mailbox: 'Custom.Mailbox',
    ManagingOwner: 'Custom.ManagingOwner',
    MeetingDetails: 'Custom.MeetingDetails',
    MigrationPartner: 'Custom.MigrationPartner',
    MilestoneID: 'Custom.MilestoneID',
    MilestoneActivations: 'Custom.MilestoneActivations',
    MilestoneAmount: 'Custom.MilestoneAmount',
    MilestoneEstDate: 'Custom.MilestoneEstDate',
    BACV: 'Custom.BACV',
    MilestoneName: 'Custom.MilestoneName',
    MitigationPlan: 'Custom.MitigationPlan',
    PrimaryWorkload: 'Custom.Primary_Workload',
    hasFastTrack: 'Custom.HasFastTrack',
    hasUnified: 'Custom.HasUnified',
    hasD365: 'Custom.HasD365',
    escalationReason: 'Custom.EscalationReason',
    secondaryEscalationReason: 'Custom.SecondaryEscalationReason',
    tertiaryEscalationReason: 'Custom.TertiaryEscalationReason',
    NextAction: 'Custom.NextAction',
    Notes: 'Custom.Notes',
    oneAskID: ManageViewConstants.IsProduction
      ? 'Custom.5ec0f5af-38c8-4c1a-8b12-09efd2d98d94'
      : 'Custom.00204309-6f2a-4083-8664-174cbdf151ef',
    OneListID: 'Custom.OneListID',
    Opportunity_ID: 'Custom.Opportunity_ID',
    Opportunity_Size: 'Custom.Opportunity_Size',
    PartnerOneName: 'Custom.PartnerOneName',
    ProductOpportunitySize: 'Custom.ProductOpportunitySize',
    Products: 'Custom.Products_New',
    Product: 'Products(s)',
    ProductsOld: 'Custom.Products',
    ProgramNew: 'Custom.Program_NEW',
    ProgramOld: 'Custom.Program',
    QBCNotes: 'Custom.QBCNotes',
    QuarterSerialNumber: 'Custom.QuarterSerialNumber',
    RefID: 'Custom.RefID',
    RelatedIssue: 'Custom.RelatedIssue',
    RequestedBy: 'Custom.RequestedBy',
    RequestedDate: 'Custom.RequestedDate',
    Requestor: 'Custom.Requestor',
    Requestors: 'Custom.Requestors',
    SalesPlay: 'Custom.SalesPlay',
    Segment: 'Custom.Segment',
    Sender: 'Custom.Sender',
    AnnualRevenueImpact: 'Custom.AnnualRevenueImpact',
    AnnualRevenueDecimal: 'Custom.AnnualRevenueDecimal',
    NumberofSeats: 'Custom.NumberofSeats',
    ExplanationOfNeededBy: 'Custom.WhatDateIsThisNeededBy',
    FedSalesOpportunityId: 'Custom.FedSalesOpportunityID',
    FedSalesOpportunityDate: 'Custom.FedSalesOpportunityDate',
    Source: 'Custom.Source',
    StatusUpdate: 'Custom.StatusUpdate',
    StrategicAccount: 'Custom.StrategicAccount',
    Subsegment: 'Custom.Subsegment',
    Country: 'Custom.UATCountry',
    AccountID: 'Custom.UATAccountID',
    PrimaryCompetitor: 'Custom.PrimaryCompetitor',
    TPID: 'Custom.TPID',
    Test: 'Custom.Test',
    Topic: 'Custom.Topic',
    TranslatedAccountName: 'Custom.TranslatedAccountName',
    UserChangedBy: 'Custom.UserChangedBy',
    UserChangedDate: 'Custom.UserChangedDate',
    tftCreated: ManageViewConstants.IsProduction
      ? 'Custom.36520105-2048-4366-8c5e-7ef1c19cb0e3'
      : 'Custom.c1f2fddd-c94e-4ad7-a789-972c51dc3c7c',
    tftCreatedOldOne: 'Custom.TFTCreated',
    tftCreatedOldTwo: 'Custom.a615160f-764c-4b25-b7ef-5e6da7f0cb35',
    tftCreatedNew: 'Custom.c1f2fddd-c94e-4ad7-a789-972c51dc3c7c',
    StateChangeDate: 'Microsoft.VSTS.Common.StateChangeDate',
    WorkAroundDetails: ManageViewConstants.IsProduction
      ? 'Custom.fa152cba-9ede-4c97-8281-2985105a4bfb'
      : 'Custom.WorkaroundDetails',
    AcceptanceCriteria: 'Microsoft.VSTS.Common.AcceptanceCriteria',
    ActivatedBy: 'Microsoft.VSTS.Common.ActivatedBy',
    AlternativeSolutions: 'Custom.Alternativesolutions',
    AppLaunchInstructions: 'Microsoft.VSTS.Feedback.ApplicationLaunchInstructions',
    AppStartInformation: 'Microsoft.VSTS.Feedback.ApplicationStartInformation',
    AssociatedContext: 'Microsoft.VSTS.CodeReview.Context',
    AssociatedContextCode: 'Microsoft.VSTS.CodeReview.ContextCode',
    AssociatedContextOwner: 'Microsoft.VSTS.CodeReview.ContextOwner',
    AutomatedTestId: 'Microsoft.VSTS.TCM.AutomatedTestId',
    AutomatedTestName: 'Microsoft.VSTS.TCM.AutomatedTestName',
    AutomatedTestStorage: 'Microsoft.VSTS.TCM.AutomatedTestStorage',
    AutomatedTestType: 'Microsoft.VSTS.TCM.AutomatedTestType',
    DueDate: 'Microsoft.VSTS.Scheduling.DueDate',
    Resolution: 'Microsoft.VSTS.Common.Resolution',
    ContextCode: 'Microsoft.VSTS.CodeReview.ContextCode',
    BacklogPriority: 'Microsoft.VSTS.Common.BacklogPriority',
    BusinessValue: 'Microsoft.VSTS.Common.BusinessValue',
    Effort: 'Microsoft.VSTS.Scheduling.Effort',
    LocalDataSource: 'Microsoft.VSTS.TCM.LocalDataSource',
    RemainingWork: 'Microsoft.VSTS.Scheduling.RemainingWork',
    ReviewedBy: 'Microsoft.VSTS.Common.ReviewedBy',
    parameters: 'Microsoft.VSTS.TCM.Parameters',
    TestSuiteTypeId: 'Microsoft.VSTS.TCM.TestSuiteTypeId',
    TimeCriticality: 'Microsoft.VSTS.Common.TimeCriticality',
    AreaId: 'System.AreaId',
    AreaLevel1: 'System.AreaLevel1',
    AreaLevel2: 'System.AreaLevel2',
    AssignedTo: 'System.AssignedTo',
    AuthorizedAs: 'System.AuthorizedAs',
    AuthorizedDate: 'System.AuthorizedDate',
    ChangedBy: 'System.ChangedBy',
    ChangedDate: 'System.ChangedDate',
    CommentCount: 'System.CommentCount',
    CreatedBy: 'System.CreatedBy',
    CreatedDate: 'System.CreatedDate',
    ClosedBy: 'Microsoft.VSTS.Common.ClosedBy',
    ClosedDate: 'Microsoft.VSTS.Common.ClosedDate',
    Description: 'System.Description',
    ExternalLinkCount: 'System.ExternalLinkCount',
    IterationId: 'System.IterationId',
    IterationLevel1: 'System.IterationLevel1',
    NodeName: 'System.NodeName',
    PersonId: 'System.PersonId',
    Rev: 'System.Rev',
    RevisedDate: 'System.RevisedDate',
    TeamProject: 'System.TeamProject',
    Title: 'System.Title',
    Watermark: 'System.Watermark',
    PreferredPartnerName: 'Custom.PreferredPartnerName',
    Requestor1: 'Custom.Requestor1',
    LicensingProgram: 'Custom.LicensingProgram',
    PackageId: 'Custom.PackageId',
    PackageName: 'Custom.PackageName',
    MilestoneOwner: 'Custom.MilestoneOwner',
    Competitors: 'Custom.Competitors',
    CustomerGoalState: ManageViewConstants.IsProduction
      ? 'Custom.Customergoalstate'
      : 'Custom.CustomerGoalStateField',
    CustomerScenario: 'Custom.CustomerScenario',
    CustomerImpact: 'Custom.CustomerImpact',
    CompeteParity: 'Custom.Competeparity',
    ReproSteps: 'Microsoft.VSTS.TCM.ReproSteps',
    ObservedOutput: 'Custom.ObservedOutput',
    ExpectedOutput: 'Custom.ExpectedOutput',
    EngineeringWorkItemURL: 'Custom.EngineeringWorkItemURL',
    EstimatedDateToComplete: 'Custom.EstimatedDateToComplete',
    CurrentDefault: 'Custom.CurrentDefault',
    UnblockcustomerETA: 'Custom.UnblockcustomerETA',
    PubliclyDocumentedETA: 'Custom.PubliclyDocumentedETA',
    OpportunityName: 'Custom.OpportunityName',
    OpportunityStage: 'Custom.OpportunityStage',
    ListeningCircleSessionName: 'Custom.ListeningCircleSessionName',
    ListeningCircleSessionDate: 'Custom.ListeningCircleSessionDate',
    ListeningCircleChangeLead: 'Custom.ListeningCircleChangeLeads',
    ListeningCircleFacilitator: 'Custom.ListeningCircleFacilitators',
    EstMonthlyUsages: 'Custom.EstMonthlyUsages',
    ChildItems: 'Child Items',
    RelatedItems: 'Related Items',
    RemoteRelatedActions: 'Remote Related Actions',
    TenantID: 'Custom.TenantID',
    CustomerGoLiveDate: 'Custom.CustomerGoLiveDate',
    ProjectedAppMAUfortheproposedsolution: 'Custom.ProjectedAppMAUfortheproposedsolution',
    MAUImpact: 'Custom.ApexMAUImpact',
    AnyOtherDetails: 'Custom.Anyotherdetails',
    PartnerOneID: 'Custom.PartnerOneId',
    BusinessScenario: 'Custom.ProblemDetails',
    InternalTriageDate: 'Custom.InternalTriageDate',
    TriageComments: 'Custom.TriageComments',
    Stakeholders: 'Custom.Stakeholders',
    BusinessImpact: 'Custom.BusinessImpact',
    TicketVolumePerMonth: 'Custom.TicketVolumePerMonth',
    RejectedDate: 'Custom.RejectedDate',
    SupportScenariosImpacted: 'Custom.SupportScenariosImpacted',
    Synthesizer: 'Custom.Synthesizer',
    ActualCreatedDate: 'Custom.ActualCreateddate',
    ExecutingTeamADOLink: 'Custom.ExecutingTeamADOLink',
    ApexPartnerName: 'Custom.ApexPartnerName',
    RequestTypeDescription: 'Custom.RequestTypeDescription',
    HighLevelBusinessChallenge: 'Custom.HighLevelBusinessChallenge',
    AzureCapacityType: 'Custom.AzureCapacityTypeMultiline',
    AOAIDateCustodyReady: 'Custom.AOAI_DateCustomerReady',
    AOAI_SubscriptionId: 'Custom.AOAI_SubscriptionID',
    AOAI_SegmentType: 'Custom.AOAI_SegmentType',
    AOAI_RequestedAmount: 'Custom.AOAI_RequestedAmount',
    AOAI_DateDecided: 'Custom.AOAI_DateDecided',
    AOAI_Amount: 'Custom.AOAI_Amount',
    AzurePrefferedRegion: 'Custom.AzurePreferredRegion',
    AOAI_AppIDQuotaID: 'Custom.AOAI_QuotaID',
    Nominations: 'Custom.Nominations',
    UATAccountID: 'Custom.UATAccountID',
    Nominated_OpportunityType: 'Custom.Nominated_OpportunityType',
    CSM_Nomination: 'Custom.CSM_Nomination',
    MW_WaveName: 'Custom.MW_WaveName',
    WaveID_Selected: 'Custom.WaveID_Selected',
    Enrolled_Contacts: 'Custom.Enrolled_Contacts',
    Enrolled_Contact_Options: 'Custom.Enrolled_Contact_Options',
    MW_Nominated_Product: 'Custom.MW_Nominated_Product',
    RB_CustomerTPID: 'Custom.RB_CustomerTPID',
    RB_CRMAccountID: 'Custom.RB_CRMAccountID',
    RB_CompanyName: 'Custom.RB_CompanyName',
    RB_CustomerContactName: 'Custom.RB_CustomerContactName',
    RB_CustomerContactEmail: 'Custom.RB_CustomerContactEmail',
    RB_CustomerContactNumber: 'Custom.RB_CustomerContactNumber',
    RB_CSSCaseNumber: 'Custom.RB_CSSCaseNumber',
    RB_GetHelpTicketNumber: 'Custom.RB_GetHelpTicketNumber',
    RB_UsersImpacted: 'Custom.RB_UsersImpacted',
    RB_CustomerRevenueImpacted: 'Custom.RB_CustomerRevenueImpacted',
    RB_GetHelpTicketCreationDate: 'Custom.RB_GetHelpTicketCreationDate',
    RB_SSSPFullName: 'Custom.RB_SSSPFullName',
    RB_SSSPEmail: 'Custom.RB_SSSPEmail',
    RB_BlockedProductOpportunityID: 'Custom.RB_BlockedProductOpportunityID',
    RB_MSFTProductBlockedRevenue: 'Custom.RB_MSFTProductBlockedRevenue',
    RB_BlockedUSOOpportunityID: 'Custom.RB_BlockedUSOOpportunityID',
    RB_USOBlockedRevenue: 'Custom.RB_USOBlockedRevenue',
    BilledRevenue: 'Custom.EstedBilledRevenue',
    RB_TerritoryName: 'Custom.RB_TerritoryName',
    RB_SalesTerritory: 'Custom.RB_SalesTerritory',
    RB_CaseNumber: 'Custom.RB_CaseNumber',
    RB_CurrentFYRevenue: 'Custom.RB_CurrentFYRevenue',
    RB_BlockedOpportunityRevenue: 'Custom.RB_BlockedOpportunityRevenue',
    RB_NSCStartDate: 'Custom.RB_NSCStartDate',
    RB_CaseClosedDate: 'Custom.RB_CaseClosedDate',
    RB_CSSCaseCreationDate: 'Custom.RB_CSSCaseCreationDate',
    CAPSL_AccountPartnerName: 'Custom.CAPSL_accountPartnerName',
    CAPSL_AccountTPID: 'Custom.CAPSL_accountTPID',
    CAPSL_BusinessJustification: 'Custom.CAPSL_BusinessJustification',
    CAPSL_ContactAlias: 'Custom.CAPSL_ContactAlias',
    CAPSL_Title: 'Custom.CAPSL_Title',
    CAPSL_FirstName: 'Custom.CAPSL_FirstName',
    CAPSL_LastName: 'Custom.CAPSL_LastName',
    CAPSL_AM_PDMName: 'Custom.CAPSL_AMName',
    CAPSL_SuppressChildAccount: 'Custom.CAPSL_SuppressChildAccount',
    CAPSL_AccountName: 'Custom.CAPSL_AccountName',
    ECIF_AdditionalContacts: 'Custom.ECIF_AdditionalContacts',
    ECIF_ApprovedDate: 'Custom.ECIF_ApprovedDate',
    ECIF_CompletionDate: 'Custom.ECIF_CompletionDate',
    ECIF_Investment: 'Custom.ECIF_Investment',
    ECIF_InvestmentApproved: 'Custom.ECIF_InvestmentApproved',
    ECIF_ROI: 'Custom.ECIF_ROI',
    ECIF_IncrementalRev: 'Custom.ECIF_IncrementalRevenue',
    ECIF_Spend: 'Custom.ECIF_Spend',
    ECIF_StartDate: 'Custom.ECIF_StartDate',
    ECIF_SupplierName: 'Custom.ECIF_SupplierName',
    ECIF_SupplierType: 'Custom.ECIF_SupplierType',
    ECIF_CommericalExecutive: 'Custom.ECIF_CommericalExecutive',
    ECIF_ApprovedBy: 'Custom.ECIF_ApprovedBy',
    ECIF_ProjectDetails: 'Custom.ECIF_ProjectDetails',
    ECIF_DealDetails: 'Custom.ECIF_DealDetails',
    ECIF_ActionCategoryField: 'Custom.ActionCategoryField',
    ECIF_ExpectedOutcome: 'Custom.ECIF_ExpectedOutcome',
    ECIF_EvaluateWork: 'Custom.ECIF_EvaluateWork',
    ECIF_Rejectedby: 'Custom.ECIF_RejectedBy',
    ECIF_EnrollmentNumber: 'Custom.ECIFCustomerEnrollmentNumber',
    ECIF_RejectedDate: 'Custom.ECIF_RejectedDate',
    ECIF_RequestJustification: 'Custom.ECIF_RequestJustification',
    MaaS_DocumentCreationDate: 'Custom.MaaS_DocumentCreationDate',
    MaaS_DocumentLink: 'Custom.MaaS_DocumentLink',
    MaaS_ReplacemyExistingList: 'Custom.MaaS_ReplacemyExistingList',
    MaaS_AdditionalComments: 'Custom.MaaS_AdditionalComments',
    MaaS_AccountCRMID: 'Custom.MaaS_AccountCRMID',
    MaaS_CustomerWebURL: 'Custom.MaaS_CustomerWebURL',
    MaaS_SpecificNameForBDM: 'Custom.MaaS_SpecificNameForBDM',
    MaaS_SpecificTitleForBDM: 'Custom.MaaS_SpecificTitleForBDM',
    MaaS_tpids: 'Custom.MaaS_tpids',
    MaaS_AccountName: 'Custom.MaaS_AccountName',
    MaaS_ChildAccount: 'Custom.MaaS_ChildAccount',
    MaaS_EventName: 'Custom.MaaS_EventName',
    MaaS_EventType: 'Custom.MaaS_EventType',
    MaaS_EventDate: 'Custom.MaaS_EventDate',
    MaaS_EventRegistrationURL: 'Custom.MaaS_EventRegistrationURL',
    MaaS_MarketingPlay: 'Custom.MaaS_MarketingPlay',
    MaaS_SMPPApprovalID: 'Custom.MaaS_SMPPApprovalID',
    MaaS_DataCaptureDate: 'Custom.MaaS_DataCaptureDate',
    MaaS_LeadSourceType: 'Custom.MaaS_LeadSourceType',
    State_InProgress: 'In Progress',
    State_Dispatched: 'Dispatched',
    State_OnHold: 'On Hold',
    State_Done: 'Done',
    State_Removed: 'Removed',
    SubState_Noactionrequired: 'No Action Required',
    SubState_New: 'New',
    SubState_Resolved: 'Resolved',
    SubState_NA: 'N/A',
    MaaS_EventContactListpassword: 'Custom.MaaS_EventContactListPassword',
    MaaS_PrivacyApprovalEmail: 'Custom.MaaS_PrivacyApprovalEmail',
    MaaS_EventSponsorshipAgreement: 'Custom.MaaS_EventSponsorshipAgreement',
    Maas_Privacy_Approval_Email: 'Privacy approval email',
    Maas_Event_Sponsorship_Agreement: 'Event sponsorship agreement',
    RevenueImpact: 'Custom.RevenueImpact',
    MaccImpact: 'Custom.MACCImpact',
    MaccDuration: 'Custom.MACCDuration',
    PMYT_Areas: 'Custom.PMYT_Areas',
    PMYT_CampaignName: 'Custom.PMYT_CampaignName',
    PMYT_CoInvestmentAmount: 'Custom.PMYT_CoInvestmentAmount',
    PMYT_SourceOfInvestment: 'Custom.PMYT_SourceOfInvestment',
    PMYT_InvestmentAmount: 'Custom.PMYT_InvestmentAmount',
    PMYT_SolutionPlays: 'Custom.PMYT_SolutionPlays',
    PMYT_Industries: 'Custom.PMYT_Industries',
    PMYT_EstimatedStartDate: 'Custom.PMYT_EstimatedStartDate',
    PMYT_EstimatedPipelineRevenue: 'Custom.PMYT_EstimatedPipelineRevenue',
    PMYT_PartnerType: 'Custom.PMYT_PartnerType',
    PMYT_CustomerSegment: 'Custom.PMYT_CustomerSegment',
    PMYT_EstimatedCosellReferrals: 'Custom.PMYT_EstimatedCosellReferrals',
    CoSellSubCategoryTopic: 'Custom.CoSell_SubCategoryTopic',
    CoSellActivity: 'Custom.CoSell_Activity',
    CoSellPartnerRegion: 'Custom.CoSell_PartnerRegion',
    CoSellPartnerCountry: 'Custom.CoSell_PartnerCountry',
    CoSellPartnerArea: 'Custom.CoSell_PartnerArea',
    CoSellDeliveryLanguageSupport: 'Custom.CoSell_DeliveryLanguageSupport',
    CoSellPartnerEngaged: 'Custom.CoSell_PartnerEngaged',
    CoSellMCEMSalesStage: 'Custom.CoSell_MCEMSalesStage',
    CoSellDealStatus: 'Custom.CoSell_DealStatus',
    CoSellPartnerContactName: 'Custom.CoSell_PartnerContactName',
    CoSellPartnerEmail: 'Custom.CoSell_PartnerEmail',
    CoSellReferralID: 'Custom.CoSell_ReferralID',
    CoSellDealValue: 'Custom.CoSell_DealValue',
    CoSellDealCreatedDate: 'Custom.CoSell_DealCreatedDate',
    CoSellDateAccepted: 'Custom.CoSell_DateAccepted',
    CoSellDateExpired: 'Custom.CoSell_DateExpired',
    CoSellExpectedExpirationDate: 'Custom.CoSell_ExpectedExpirationDate',
    CoSellMicrosoftCoOwner: 'Custom.CoSell_MicrosoftCoOwner',
    CoSellRequestCategory: 'Custom.CoSell_RequestCategory',
    CoSellMicrosoftOwner: 'Custom.CoSell_MicrosoftOwner',
    CoSellAssignmentDate: 'Custom.CoSell_AssignmentDate',
    MaccAeAlias: 'MACC_AE_Alias',
    MaccCeAlias: 'MACC_CE_Alias',
    MaccSSSPAlias: 'MACC_SSSP_Alias',
    RAID_Type: 'Custom.RAID_Type',
    Raid_Priority: 'Custom.Raid_Priority',
    RAID_Status: 'Custom.RAID_Status',
    Raid_ResolutionPlan: 'Custom.Raid_ResolutionPlan',
    Raid_ResolutionProgress: 'Custom.Raid_ResolutionProgress',
    Raid_DateOpened: 'Custom.Raid_DateOpened',
    Raid_DateClosed: 'Custom.Raid_DateClosed',
    Raid_RelatedItems: 'Custom.Raid_RelatedItems',
    Raid_RelatedItemID: 'Custom.Raid_RelatedItemID',
    Raid_RelatedItemTitle: 'Custom.Raid_RelatedItemTitle',
    Raid_RelatedItemStatus: 'Custom.Raid_RelatedItemStatus',
    Raid_RelatedItemType: 'Custom.Raid_RelatedItemType',
    GPS_PIRReviewDate: 'Custom.GPS_PIRReviewDate',
    GPS_DiscussionType: 'Custom.GPS_DiscussionType',
    GPS_RequestType: 'Custom.GPS_RequestType',
    GPS_Business: 'Custom.GPS_Business',
    GPS_DealEconomics: 'Custom.GPS_DealEconomics',
    GPS_Product: 'Custom.GPS_Product',
    GPS_PartnerOneID: 'Custom.GPS_PartnerOneID',
    GPS_PartnerOneName: 'Custom.GPS_PartnerOneName',
    GPS_Areas: 'Custom.GPS_Areas',
    GPS_StartDate: 'Custom.GPS_StartDate',
    GPS_EndDate: 'Custom.GPS_EndDate',
    GPS_InvestmentType: 'Custom.GPS_InvestmentType',
    GPS_InvestmentAmount: 'Custom.GPS_InvestmentAmount',
    GPS_Stage: 'Custom.GPS_Stage',
    GPS_MigratedDate: 'Custom.GPS_MigratedDate',
    GPS_InvestmentComplexity: 'Custom.GPS_InvestmentComplexity',
    GPS_StrategyLead: 'Custom.GPS_StrategyLead',
    GPS_StrategyApproval: 'Custom.GPS_StrategyApproval',
    GPS_EscalationDate: 'Custom.GPS_EscalationDate',
    GPS_ExecutionPathQubitID: 'Custom.GPS_ExecutionPathQubitID',
    GPS_ContractSignDate: 'Custom.GPS_ContractSignDate',
    GPS_PartnerType: 'Custom.GPS_PartnerType',
    GPS_MCEMStagetext: 'Custom.GPS_MCEMStagetext',
    GPS_DueDate: 'Custom.GPS_DueDate',
    GPS_PolicyDeclaration: 'Custom.GPS_PolicyDeclaration',
    GPS_BusinessCaseSubmitted: 'Custom.GPS_BusinessCaseSubmitted',
    GPS_PIRReviewScheduled: 'Custom.GPS_PIRReviewScheduled',
    GPS_FinancialModelSubmitted: 'Custom.GPS_FinancialModelSubmitted',
    GPS_OpsIntakeRequired: 'Custom.GPS_OpsIntakeRequired',
    GPS_OpsIntakeMeetingDate: 'Custom.GPS_OpsIntakeMeetingDate',
    GPS_OpsIntakeComplete: 'Custom.GPS_OpsIntakeComplete',
    GPS_NextStepsCompleted: 'Custom.GPS_NextStepsCompleted',
    GPS_ApprovedInQubit: 'Custom.GPS_ApprovedInQubit',
    GPS_PIRDecisionDate: 'Custom.GPS_PIRDecisionDate',
    GPS_PIRManager: 'Custom.GPS_PIRManager',
    GPS_PIRDecision: 'Custom.GPS_PIRDecision',
    GPS_PIRManagerNextStepsExceptionsNotes: 'Custom.GPS_PIRManagerNextStepsExceptionsNotes',
    GPS_OperationsApproval: 'Custom.GPS_OperationsApproval',
    GPS_OperationsPIRStakeholderName: 'Custom.GPS_OperationsPIRStakeholderName',
    GPS_OperationsNextStepsExceptionsNotes: 'Custom.GPS_OperationsNextStepsExceptionsNotes',
    GPS_DraftContract: 'Custom.GPS_DraftContracts',
    GPS_CELAReview: 'Custom.GPS_CELAReview',
    GPS_CELAPIRStakeholderName: 'Custom.GPS_CELAPIRStakeholderName',
    GPS_CELANextStepsExceptionsNotes: 'Custom.GPS_CELANextStepsExceptionsNotes',
    GPS_ComplianceReview: 'Custom.GPS_ComplianceReview',
    GPS_CompliancePIRStakeholder: 'Custom.GPS_CompliancePIRStakeholder',
    GPS_ComplianceNextStepsExceptionsNotes: 'Custom.GPS_ComplianceNextStepsExceptionsNotes',
    GPS_CorpAccountingReview: 'Custom.GPS_CorpAccountingApproval',
    GPS_CorpAccountingPIRStakeholder: 'Custom.GPS_CorpAccountingPIRStakeholder',
    GPS_CorpAccountingNextStepsExceptionsNotes: 'Custom.GPS_CorpAccountingNextStepsExceptionsNotes',
    GPS_ExpectedIncrementalRevenue: 'Custom.GPS_ExpectedIncrementalRevenue',
    GPS_FinanceApproval: 'Custom.GPS_FinanceApproval',
    GPS_FinancePIRStakeholder: 'Custom.GPS_FinancePIRStakeholder',
    GPS_FinanceNextStepsExceptionsNotes: 'Custom.GPS_FinanceNextStepsExceptionsNotes',
    GPS_FundingSource: 'Custom.GPS_FundingSource',
    GPS_FundingType: 'Custom.GPS_FundingType',
    GPS_RevAdjust: 'Custom.GPS_RevAdjust',
    GPS_Opex: 'Custom.GPS_Opex',
    GPS_ACO: 'Custom.GPS_ACO',
    GPS_ECIF: 'Custom.GPS_ECIF',
    GPS_Sponsorship: 'Custom.GPS_Sponsorship',
    GPS_Skilling: 'Custom.GPS_Skilling',
    GPS_InternalResources: 'Custom.GPS_InternalResources',
    GPS_BusinessCase: 'Custom.GPS_BusinessCase',
    GPS_FinancialModel: 'Custom.GPS_FinancialModel',
    GPS_PartnerList: 'Custom.GPS_PartnerList',
    GPS_ControlList: 'Custom.GPS_ControlList',
    GPS_Notes: 'Custom.GPS_Notes',
    GPS_ComplianceandOngoingMonitoring: 'Custom.GPS_ComplianceandOngoingMonitoring',
    GPS_PIR_CASEID: 'Custom.GPS_PIR_CASEID',
    GPS_EngagementType: 'Custom.GPS_EngagementType',
    GPS_GLPCCode: 'Custom.GPS_GLPCCode',
    GPS_SAPGLCode: 'Custom.GPS_SAPGLCode',
    GPS_AskType: 'Custom.GPS_AskType',
    GSI_Title: 'Custom.GSI_Title',
    GSI_AssignedTo: 'Custom.GSI_AssignedTo',
    GSI_Requestors: 'Custom.GSI_Requestors',
    GSI_AreaPath: 'Custom.GSI_AreaPath',
    GSI_State: 'Custom.GSI_State',
    GSI_SubState: 'Custom.GSI_SubState',
    GSI_TPID: 'Custom.GSI_TPID',
    GSI_PartnerOneId: 'Custom.GSI_PartnerOneId',
    GSI_PartnerOneName: 'Custom.GSI_PartnerOneName',
    GSI_BudgetProgram: 'Custom.GSI_BudgetProgram',
    GSI_CreditAmountUSD: 'Custom.GSI_CreditAmountUSD',
    GSI_CreditStartDate: 'Custom.GSI_CreditStartDate',
    GSI_EnrollmentId: 'Custom.GSI_enrollmentid',
    GSI_PartnerType: 'Custom.GSI_PartnerType',
    GSI_DealStructure: 'Custom.GSI_dealstructure',
    GSI_CommercialExecutiveCE: 'Custom.GSI_commercialexecutivece',
    GSI_Emails: 'Custom.GSI_Emails',
    GSI_RequestReason: 'Custom.GSI_requestreason',
    GSI_Approver: 'Custom.GSI_approver',
    GSI_BusinessJustification: 'Custom.GSI_BusinessJustification',
    GSI_StatusUpdate: 'Custom.GSI_statusupdate',
    GSI_CreatedDate: 'Custom.GSI_createddate',
    GSI_CreatedBy: 'Custom.GSI_createdby',
    GSI_UserChangedBy: 'Custom.GSI_UserChangedBy',
    GSI_RaidRelations: 'Custom.GSI_RaidRelations',
    AMM_NextBestAction: 'Custom.AMM_NextBestAction',
    AMM_NextBestActionDetails: 'Custom.AMM_NextBestActionDetails',
    AMM_ActionTaken: 'Custom.AMM_ActionTaken',
    AMM_ActionTakenDetails: 'Custom.AMM_ActionTakenDetails',
    AMM_CancellationReason: 'Custom.AMM_CancellationReason',
    AMM_CancellationAdditionalDetails: 'Custom.AMM_CancellationAdditionalDetails',
    AMM_RejectionReason: 'Custom.AMM_RejectionReason',
    AMM_RejectionAdditionalDetails: 'Custom.AMM_RejectionAdditionalDetails',
    AMM_DisqualificationReason: 'Custom.AMM_DisqualificationReason',
    AMM_DisqualificationAdditionalDetails: 'Custom.AMM_DisqualificationAdditionalReason',
    AMM_OFFER_MigrationFactory: 'AMM - CSU Migration Factory',
    AMM_OFFER_AMMAPAzureAccess: 'AMM - Azure Access',
    AMM_OFFER_AzureCreditOffer: 'Azure Credit Offer',
    AMM_OFFER_PreSalesECIF: 'AMM - Pre-Sales ECIF',
    AMM_OFFER_PostSalesECIF: 'AMM - Post-Sales ECIF',
    AMM_OFFER_FieldECIF: 'AMM - Field ECIF', //It is a Copy of Azure Accelerate ECIF/Postsale Ecif for FY27
    AMM_OFFER_FutureGrowthACO: 'AMM - Future Growth Azure Credit Offer',
    AMM_OFFER_MigrateOracleACO: 'AMM - Migrate Oracle Azure Credit Offer',
    AMM_OFFER_MIGRATEORACLE: 'AMM - Migrate Oracle ECIF',
    AMM_OFFER_LocalACO: 'AMM - Local Azure Credit Offer',
    AMM_OFFER_SAP_Azure: 'AMM - SAP Azure Credit Offer',
    AMM_OFFER_AVSACO: 'AMM - AVS Azure Credit Offer',
    AMM_OFFER_FutureGrowthECIF: 'AMM - Future Growth ECIF',
    AMM_OFFER_SAPRISECIF: 'AMM - SAP RISE ECIF',
    AMM_Offer: 'Custom.AMM_Offer',
    AMM_RequestType: 'Custom.AMM_RequestType',
    AMM_CaseCreatedDateTime: 'Custom.AMM_CaseCreatedDateTime',
    AMM_PendingActionFrom: 'Custom.AMM_PendingActionFrom',
    AMM_OfferEngineStatus: 'Custom.AMM_OfferEngineStatus',
    AMM_AVSOfferEngineStatus: 'Custom.AMM_AVSOfferEngineStatus',
    AMM_CMFOfferEngineStatus: 'Custom.AMM_CMFOfferEngineStatus',
    AMM_ECIFOfferEngineStatus: 'Custom.AMM_ECIFOfferEngineStatus',
    AMM_AVSOfferEngineType: 'Custom.AMM_AVSOfferEngineType',
    AMM_CMFOfferEngineType: 'Custom.AMM_CMFOfferEngineType',
    AMM_ECIFOfferEngineType: 'Custom.AMM_ECIFOfferEngineType',
    AMM_OriginatingCaseID: 'Custom.AMM_OriginatingCaseID',
    AMM_ProgramFunding: 'Custom.AMM_ProgramFunding',
    AMM_AAOfferType: 'Custom.AMM_AAOferType',
    AMM_SponsorshipAmount: 'Custom.AMM_SponsorshipAmount',
    AMM_OFFER_MigrateAndSecureSolutionAssessment:
      'AMM - Migrate and Secure WIN/SQL/LIN Solution Assessment',
    AMM_CaseDuration: 'Custom.AMM_CaseDuration',
    AMM_SLARemainingTime: 'Custom.AMM_SLARemainingTime',
    AMM_CaseNotes: 'Custom.AMM_CaseNotes',
    AMM_ProjectSize: 'Custom.AMM_ProjectSize',
    AMM_TotalACR: 'Custom.AMM_TotalACR',
    AMM_PreOrPost: 'Custom.AMM_PreOrPost',
    AMM_RequestJustification: 'Custom.AMM_RequestJustification',
    AMM_ExpectedProjectStartDate: 'Custom.AMM_ExpectedProjectStartDate',
    AMM_ExpectedProjectEndDate: 'Custom.AMM_ExpectedProjectEndDate',
    AMM_AccountOwnerID: 'Custom.AMM_AccountOwnerID',
    AMM_TermsandConditionEmail: 'Custom.AMM_TermsandConditionEmail',
    AMM_SupportRegion: 'Custom.AMM_SupportRegion',
    AMM_MicrosoftCCRecipient: 'Custom.AMM_MicrosoftCCRecipient',
    AMM_CustomerCCList: 'Custom.AMM_CustomerCCList',
    AMM_needawaveplan: 'Custom.AMM_needawaveplan',
    AMM_RequesterArea: 'Custom.AMM_RequesterArea',
    AMM_DeliveryPartnerEligibility: 'Custom.AMM_DeliveryPartnerEligibility',
    AMM_TotalForOfferEligibleACR: 'Custom.AMM_TotalForOfferEligibleACR',
    AMM_EnrollmentNumber: 'Custom.AMM_EnrollmentNoOrBillingAcID',
    AMM_MigrationorModernization: 'Custom.AMM_IsThisAssessmentMeantToAddressAppMigration',
    AMM_SolutionAssessmentType: 'Custom.AMM_SolutionAssessmentType',
    AMM_MigrationPartnerAttached: 'Custom.AMM_MigrationPartnerAttached',
    AMM_ScopeOfWork: 'Custom.AMM_ScopeOfWork',
    AMM_CustomerCommitment: 'Custom.AMM_CustomerCommitment',
    AMM_CSAEmailAddress: 'Custom.AMM_CSAEmailAddress',
    AMM_CSA2EmailAddress: 'Custom.AMM_CSA2EmailAddress',
    AMM_CSA3EmailAddress: 'Custom.AMM_CSA3EmailAddress',
    AMM_AEATSEmailAddress: 'Custom.AMM_AEATSEmailAddress',
    AMM_SpecialistEmailAddress: 'Custom.AMM_SpecialistEmailAddress',
    AMM_TermsAndConditionEmailID: 'Custom.AMM_TermsAndConditionEmailID',
    AMM_CommunicationPreference: 'Custom.AMM_CommunicationPreference',
    AMM_CustomerContactName: 'Custom.AMM_CustomerContactName',
    AMM_CustomerContactEmail: 'Custom.AMM_CustomerContactEmail',
    AMM_CustomerAcceptedTheAssessment: 'Custom.AMM_CustomerAcceptedTheAssessment',
    Amm_Migrationpartnerattached: 'Custom.AMM_MigrationPartnerAttached',
    AMM_MigrationPartner: 'Custom.AMM_MigrationPartner',
    AMM_MigrationPartnerEmail: 'Custom.AMM_MigrationPartnerEmail',
    AMM_AEAlias: 'Custom.AMM_AEAlias',
    AMM_ATSAlias: 'Custom.AMM_ATSAlias',
    AMM_SSTSAlias: 'Custom.AMM_SSOrTSAlias',
    AMM_SecuritySSPAlias: 'Custom.AMM_SecuritySSPAlias',
    AMM_AppSSPAlias: 'Custom.AMM_AppSSPAlias',
    AMM_HelpCategory: 'Custom.AMM_HelpCategory',
    AMM_SubTitle: 'Custom.AMM_SubTitle',
    AMM_HelpDescription: 'Custom.AMM_HelpDescription',
    AMM_NeedhelpPitchingTheValue: 'Custom.AMM_NeedhelpPitchingTheValue',
    AMM_ServiceLocation: 'Custom.AMM_ServiceLocation',
    AMM_ACOID: 'Custom.AMM_ACOID',
    AMM_ACOCE: 'Custom.AMM_ACOCE',
    AMM_AcoCreditRequestAmount: 'Custom.AMM_AcoCreditRequestAmount',
    AMM_DealStructure: 'Custom.AMM_DealStructure',
    AMM_RequestReason: 'Custom.AMM_RequestReason',
    AMM_FutureGrowthOffer: 'Custom.AMM_FutureGrowthOffer',
    AMM_1stYearACR: 'Custom.AMM_1stYearACR',
    AMM_ECIFSpendPlan: 'Custom.AMM_ECIFSpendPlan',
    AMM_DoyouwanttorequestACOinadditiontoECIF: 'Custom.AMM_DoyouwanttorequestACOinadditiontoECIF',
    AMM_IsThereACompetitiveBid: 'Custom.AMM_IsThereACompetitiveBid',
    AMM_RequestAmount: 'Custom.AMM_RequestAmount',
    AMM_FTA: 'Custom.AMM_FTA',
    AMM_ESI: 'Custom.AMM_ESI',
    AMM_MicrosoftDefenderforCloud: 'Custom.AMM_MicrosoftDefenderforCloud',
    AMM_PrimarySolutionPlay: 'Custom.AMM_PrimarySolutionPlay',
    AMM_IncrementalRevenueROI: 'Custom.AMM_IncrementalRevenueROI',
    AMM_FinancialYear: 'Custom.AMM_FinancialYear',
    AMM_AAOfferType_EASponsorship: 'EA Sponsorship',
    AMM_IsThisRequestRelated: 'Custom.AMM_IsThisRequestRelatedToPublicOrGovernmentOwnedEntity',
    AMM_DoesThisIncludeHighRiskDeal: 'Custom.AMM_DoesThisIncludeHighRiskDeal',
    AMM_SAPOffer: 'Custom.AMM_SAPOffer',
    MM_RIValuePerMonth: 'Custom.AMM_RIValuePerMonth',
    AMM_IsThereAnyExistingMACCOrCTCOrMC: 'Custom.AMM_IsThereAnyExistingMACCOrCTCOrMC',
    AMM_IsThereExistingACO: 'Custom.AMM_IsThereExistingACO',
    AMM_AVSOffer: 'Custom.AMM_AVSOffer',
    AMM_IsThisAVMCToAVSMigration: 'Custom.AMM_IsThisAVMCToAVSMigration',
    AMM_AVSRIRegion: 'Custom.AMM_AVSRIRegion',
    AMM_AVSRIQuantity: 'Custom.AMM_AVSRIQuantity',
    AMM_FutureGrowthECIF: 'Custom.AMM_FutureGrowthECIF',
    AMM_PRIMARYAzurevirtualmachineVMseries: 'Custom.AMM_PRIMARYAzurevirtualmachineVMseries',
    AMM_3YearACR: 'Custom.AMM_3YearACR',
    AMM_SponsoringCountry: 'Custom.AMM_SponsoringCountry',
    AMM_OfferEngineCaseID: 'Custom.AMM_OfferEngineCaseID',
    AMM_OfferEngineType: 'Custom.AMM_OfferEngineType',
    AMM_FirstYearROI: 'Custom.AMM_1stYearROI',
    AMM_ThirdYearROI: 'Custom.AMM_3rdYearROI',
    AMM_LinkWorkScope: 'Custom.AMM_LinkWorkScope',
    AMM_LicensingProgram: 'Custom.AMM_LicensingProgram',
    AMM_TypeOfFundingNeeded: 'Custom.AMM_TypeofFundingNeeded',
    AMM_SupportedScenario: 'Custom.AMM_SupportedScenario',
    AMM_Program: 'Custom.AMM_Program',
    AMM_WillThisRequestRequireAdditionalAttendees:
      'Custom.AMM_WillthisrequestrequireadditionalAttendees',
    AMM_AzureFutureGrowthOffer: 'Custom.AMM_AzureFutureGrowthOffer',
    AMM_ECIFFutureGrowthOffer: 'Custom.AMM_ECIFFutureGrowthOffer',
    AMM_SupplierType: 'Custom.AMM_SupplierType',
    AMM_IsSupplierSameEndCustomer: 'Custom.AMM_IsSupplierSameEndCustomer',
    AMM_HelpType: 'Custom.AMM_HelpType',
    AMM_AvsOfferRequestCorrespond: 'Custom.AMM_AvsOfferRequestCorrespond',
    AMM_OfferDeskRegion: 'Custom.AMM_OfferDeskRegion',
    MACCReasonforException: 'Custom.MACC_Reason_for_Exception',
    MACCIS_Sales_Engaged: 'Custom.MACC_IS_Sales_Engaged',
    MACCCustomerHas_UnifiedAgreement: 'Custom.MACC_Customer_Has_Unified_Agreement',
  };

  public static ApiPaths = {
    GetADOTags: '/api/getADOTags',
  };

  public static Footer = {
    SaveAndApply: 'Save & Apply',
    Save: 'Save',
    Cancel: 'Cancel',
  };

  public static generateTreeView = {
    customDefaultViewFolderName: 'Default View',
    customDefaultViewFolderId: '00000000-0000-0000-0000-000000000001',
    customFavViewsFolderName: 'My Favorites',
    customFavViewsFolderId: '00000000-0000-0000-0000-000000000002',
    customSystemViewFolderName: 'System Views',
    customSystemViewFolderId: '77d00df8-e9ae-4735-80ba-6e3bce3385be',
    customSharedViewsFolderName: 'Shared Views',
    customSharedViewsFolderId: 'f57981af-7142-4fbc-84b7-2f82a53aab2d',
    customSharedWithMeViewsFolderName: 'Shared With Me',
    customSharedWithMeViewsFolderId: '95600df8-e9ae-4fbc-80ba-2f82a53aab2d',
    customUserViewsFolderName: 'My Views',
    customUserViewsFolderId: '77d00df8-e9ae-4fbc-80ba-2f82a53aab2d',
  };

  public static DefaultFolderNames = {
    DefaultView: 'Default View',
    SystemViews: 'System Views',
    SharedViews: 'Shared Views',
    MyFavorites: 'My Favorites',
    SharedWithMe: 'Shared With Me',
    MyViews: 'My Views',
  };

  public static pagination = {
    ItemsPerPage: {
      Default: 50,
    },
  };

  public static defaultSorting: IDefaultSorting = {
    column: 'System.ChangedDate',
    sortOrder: 'DESC',
  };

  public static defaultStateColor = '#5C5C5C';

  public static ActionCount = {
    Actions: 'Actions',
    NoActions: 'No Actions',
    actionCountToShow: '20000+',
    MaxADOActionsCountFromAPI: 19995,
  };

  public static ManageviewKeyTerms = {
    AssignedTeam: 'Assigned Team',
    landingPageFlag: '?landingPage=false',
    AreaPathCustom: 'areaPathCustom',
    AreaPath: 'areaPath',
    AssignToCorp: 'assignToCorp',
    DateSelectionFormat: 'dateSelectionFormat',
    Action: 'Action',
    tagName: 'tagName',
    tagMaxLength: 50,
    ellipses: '...',
    UNIFIED_ACTION_TRACKER: 'Unified Action Tracker',
    rbArea: 'rbArea',
    rbRegion: 'rbRegion',
    rbRegionArtemis: 'rb_Region',
    rbSubRegion: 'subRegion',
    rbActionOwnerGroup: 'actionOwnerGroup',
    rbCountry: 'rbCountry',
    rbTechnology: 'rbTechnology',
    rbTicketReason: 'rbTicketReason',
    rbGeneralCategory: 'rbGeneralCategory',
    rbInfraLocation: 'rbInfraLocation',
    eciffundtype: 'eciffundtype',
    ecifprogramName: 'ecifprogramName',
    ecifEntityType: 'ecifEntityType',
    ecifDeliveryMethod: 'ecifDeliveryMethod',
    yesOrNo: 'yesOrNo',
    ecifTypeofActivity: 'ecifTypeofActivity',
    MaaSRequestType: 'MaaS_RequestType',
    MaaSRole: 'MaaS_Role',
    MaaSMarketerRole: 'MaaS_Marketer_Role',
    MaaSSellerRole: 'MaaS_Seller_Role',
    MaaSArea: 'MaaS_Area',
    MaaSIndustry: 'MaaS_Industry',
    MaaSSegment: 'MaaS_Segment',
    MaaSSubSegment: 'MaaS_SubSegment',
    MaaSOU: 'MaaS_OU',
    MaaSMCEMStage: 'MaaS_MCEM_Stage',
    MaaSTechTargetexistingAccount: 'MaaS_TechTargetexistingAccount',
    MaaSExistingAccountValues: 'MaaS_ExistingAccountValues',
    MaccReasonforException: 'maccReasonforException',

    //Missed fields
    MaaSEventType: 'MaaS_EventType',
    MaaSMarketingPlay: 'MaaS_MarketingPlay',
    MaaSLeadSourceType: 'MaaS_LeadSourceType',
    AOAIModel: 'aoaiModel',
    AOAIdwrRecommendation: 'dwrRecommendation',
    GPSRequestType: 'GPS_RequestType',
    GPSDiscussionType: 'GPS_DiscussionType',
    GPSBusiness: 'GPS_Business',
    GPSProduct: 'GPS_Product',
    GPSPartnerType: 'GPS_PartnerType',
    GPSInvestmentType: 'GPS_InvestmentType',
    GPSInvestmentComplexity: 'GPS_InvestmentComplexity',
    GPSPIRDecision: 'GPS_PIRDecision',
    GPSStage: 'GPS_Stage',
    GPSFundingSource: 'GPS_FundingSource',
    GPSFundingType: 'GPS_FundingType',
    GpS_Area: 'gps_Area',
    Isv_Area: 'Isv_Area',
    GPS_AskType: 'gpsAskType',
    GPSEngagementType: 'GPS_EngagementType',
    GPSGLPCCOde: 'GPS_GLPCCOde',
    GPSSAPGLCode: 'GPS_SAPGLCode',
    Operating_Unit: 'operatingUnit',
    AMMScopeOfWork: 'AMM_ScopeOfWork',
    AmmOfferType: 'AMM_OfferType',
    AmmActionTaken: 'AMM_ActionTaken',
    AmmOffer: 'AMM_Offer',
    AmmOfferEnginestatus: 'AMM_OfferEnginestatus',
    AmmCancellationreason: 'AMM_Cancellationreason',
    AmmRejectionreason: 'AMM_Rejectionreason',
    AmmDisqualificationreason: 'AMM_DisqualificationReason',
    AmmAaofertype: 'AMM_AaoferType',
    AmmPendingactionfrom: 'AMM_PendingActionFrom',
    AmmNextbestaction: 'AMM_NextBestAction',
    AmmTypeoffundingneeded: 'AMM_TypeOfFundingNeeded',
    AmmMicrosoftdefenderforcloud: 'AMM_Microsoftdefenderforcloud',
    AmmPrimaryazurevirtualmachinevmseries: 'AMM_PrimaryAzureVirtualMachineVmSeries',
    AmmCommunicationpreference: 'AMM_CommunicationPreference',
    AmmDealstructure: 'AMM_DealStructure',
    AmmSupportRegion: 'AMM_SupportRegion',
    AmmProgram: 'AMM_Program',
    AmmSupportedScenario: 'AMM_SupportedScenario',
    AmmMigrationpartnerattached: 'AMM_MigrationPartnerAttached',
    AmmWillThisRequestRequireAdditionalAttendees: 'AMM_WillThisRequestRequireAdditionalAttendees',
    AmmRequestType: 'AMM_RequestType',
    AmmEsi: 'AMM_Esi',
    AmmFta: 'AMM_Fta',
    AMMFutureGrowthECIF: 'AMM_ECIFFutureGrowthOffer',
    AMMDoYouWantToRequestAcoInAdditionToEcif: 'AMM_DoYouWantToRequestAcoInAdditionToEcif',
    AMMFinancialYear: 'AMM_FinancialYear',
    AMMHelpType: 'AMM_HelpType',
    Ammprimaryazurevirtualmachinevmseries: 'Amm_primaryazurevirtualmachinevmseries',
    AmmPreOrPost: 'AMM_PreOrPost',
    AmmCustomerCommitment: 'AMM_CustomerCommitment',
    AMMRequestReason: 'AMM_RequestReason',
    AMMAzureFutureGrowthOffer: 'AMM_AzureFutureGrowthOffer',
    AMMECIFFutureGrowthOffer: 'AMM_ECIFFutureGrowthOffer',
    AMMPrimarySolutionPlaySupporting: 'AMM_PrimarySolutionPlaySupporting',
    AMMSupplierType: 'AMM_SupplierType',
    AMMIsSupplierSameEndCustomer: 'AMM_IsSupplierSameEndCustomer',
    AMMFutureGrowthOffer: 'AMM_FutureGrowthOffer',
    AMMServiceLocation: 'AMM_ServiceLocation',
    AMMAvsOfferRequestCorrespond: 'AMM_AvsOfferRequestCorrespond',
    AMMSapOffer: 'AMM_SapOffer',
    AMMIsThisRequestRelated: 'AMM_YesOrNo',
    AMMIsThisAVMCToAVSMigration: 'AMM_YesOrNo',
    AMMIsThereExistingACO: 'AMM_YesOrNo',
    AMMDoesThisIncludeHighRiskDeal: 'AMM_YesOrNo',
    AMMIsThereACompetitiveBid: 'AMM_YesOrNo',
    AMMOfferDeskRegion: 'AMM_OfferDeskRegion',
    AMMAVSOfferEngineStatus: 'AMM_AVSOfferEngineStatus',
    AMMCMFOfferEngineStatus: 'AMM_CMFOfferEngineStatus',
    AMMECIFOfferEngineStatus: 'AMM_ECIFOfferEngineStatus',
    AMMOfferEngineType: 'AMM_OfferEngineType',
    AMMAVSOfferEngineType: 'AMM_AVSOfferEngineType',
    AMMCMFOfferEngineType: 'AMM_CMFOfferEngineType',
    AMMECIFOfferEngineType: 'AMM_ECIFOfferEngineType',
    NoNAI_RequestType: 'NoNAI_RequestType',
    NoNAI_RegionalZonal: 'NoNAI_RegionalZonal',
    NoNAI_UOM: 'NoNAI_UOM',
    NoNAI_SKU: 'NoNAI_SKU',
    NoNAI_WorkloadImpact: 'NoNAI_WorkloadImpact',

    //AOAI Fields
    AOAIRequestedVMType: 'Custom.AOAI_RequestedVMType',
  };
}

export const MANAGE_VIEW_API_CONSTANTS = {
  GetViews: '/api/getViews',
  GetViewsWithFolders: '/api/getViewsWithFolders',
  UpdateCustomQuery: '/api/updateQuery',
  AddViewToFavorites: '/api/addToFavoriteViews',
  RemoveViewFromFavorites: '/api/removeFromFavoriteViews',
  CreateTemporaryView: '/api/createTemporaryView',
  GetAllData: '/api/V2/Actions/getActionsToExport',
  GetRunQueryData: '/api/V2/Actions/dashboard',
  GetActionsCount: '/api/V2/Actions/actionCount',
  PostUserRating: '/api/postUserRating',
  GetRatingConfig: '/api/getRatingConfig',
  GetUserRating: '/api/getUserRatings',
  MarkViewAsDefault: '/api/markAsDefault',
  DeleteUserView: '/api/deleteADOQueryById',
  DeleteFolder: '/api/deleteFolderById',
  SaveCustomQuery: '/api/saveQuery',
  CreateFolder: 'api/createFolder',
  UsersTable: '/api/usersTable',
  SearchGroups: '/api/searchGroups',
  GetDropdownData: '/api/getCosmosDropdownData',
  GetToolsName: '/api/getToolsName',
};

export const StateColorsNew: any[] = [
  { key: 'In Progress', bgColor: '#2886DE' },
  { key: 'Done', bgColor: '#107C10' },
  { key: 'Escalated', bgColor: '#FDE8EA' },
  { key: 'New', bgColor: '#7160E8' },
  { key: 'Removed', bgColor: '#BBBBBB' },
  { key: 'On Hold', bgColor: '#D77F00' },
  { key: 'Design', bgColor: 'rgb(10, 112, 181)' },
  { key: 'In Technical Feedback', bgColor: '#1AEBFF' },
  { key: 'Rejected', bgColor: '#D13438' },
  { key: 'Cancelled', bgColor: '#6E0811' },
  { key: 'Completed', bgColor: '#00CC6A' },
  { key: 'Open', bgColor: 'rgb(184, 124, 230)' },
  { key: 'Closed', bgColor: '#EEACB2' },
  { key: 'Pending', bgColor: '#605E5C' },
  { key: 'Draft', bgColor: '#EAA301' },
  { key: 'Activating Offer', bgColor: '#0027B4' },
  { key: 'Offer Activated', bgColor: '#01666D' },
  { key: 'Project Complete', bgColor: '#00CC6A' },
];

export enum FieldConstants {
  createSharedViewFlightName = 'CreateSharedView',
  createSystemViewFlightName = 'CreateSystemView',
  OCPFlight = 'OCPFlight',
  ChatGPT = 'ChatGPT',
}

export enum CustomTextForCompare {
  myViews = 'My Views',
  sharedViews = 'Shared Views',
  systemViews = 'System Views',
  userViews = 'User Views',
  dateType = 'dateType',
  additionalTheme = 'Additional Theme',
  Id = 'ID',
  sharedWithMeViews = 'Shared With Me',
}

export enum ViewTypes {
  user = 'user',
  system = 'system',
  shared = 'shared',
  sharedWithMe = 'sharedwithMe',
}

export enum HttpVerbs {
  get = 'get',
  post = 'post',
  delete = 'delete',
  put = 'put',
  patch = 'patch',
}

export enum ColumnOptionsUseCase {
  ManageView = 'ManageView',
}

export const newViewDefaultColumnOptionsList: IDisplayColumn[] = [
  {
    internalName: 'System.Id',
    displayName: 'ID',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'System.Title',
    displayName: 'Title',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'System.AssignedTo',
    displayName: 'Action Owner',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'Custom.Account',
    displayName: 'Account',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'System.State',
    displayName: 'State',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'System.ChangedDate',
    displayName: 'Changed Date',
    isDefault: true,
    customWidth: 200,
  },
];

export const newViewDefaultColumnOptionsListArtemis: IDisplayColumn[] = [
  {
    internalName: 'raidid',
    displayName: 'ID',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/title',
    displayName: 'Title',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/assignedto/uniquename',
    displayName: 'Action Owner',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/state',
    displayName: 'State',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/changeddate',
    displayName: 'Changed Date',
    isDefault: true,
    customWidth: 200,
  },
];

export const newViewDefaultColumnOptionsListArtemisROB: IDisplayColumn[] = [
  {
    internalName: 'raidid',
    displayName: 'ID',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/title',
    displayName: 'Title',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/assignedto/uniquename',
    displayName: 'Action Owner',
    isDefault: true,
    customWidth: 200,
  },
  {
    internalName: 'fields/actionownergroup',
    displayName: 'Action Owner Group',
    isDefault: false,
    customWidth: 200,
  },
  {
    internalName: 'fields/state',
    displayName: 'State',
    isDefault: false,
    customWidth: 200,
  },
  {
    internalName: 'fields/requestorsinfo/uniquename',
    displayName: 'Requestors',
    isDefault: false,
    customWidth: 200,
  },
  {
    internalName: 'fields/regions',
    displayName: 'Region(s)',
    isDefault: false,
    customWidth: 200,
  },
  {
    internalName: 'raidrelations/msxaccounts/accounts/opportunities/solutionarealist',
    displayName: 'Solution Area',
    isDefault: false,
    customWidth: 200,
  },
  {
    internalName: 'fields/relatedtechrobid',
    displayName: 'Related Tech RoB ID(s)',
    isDefault: false,
    customWidth: 200,
  },
];

export const ArtemisDefaultQueryGroupClause: Clause = {
  column: {
    displayName: 'Action Owner',
    internalName: 'fields/assignedto/uniquename',
  },
  operator: {
    id: 1,
    operatorInternalName: '<>',
  },
  values: [],
};

export const ArtemisAllActionsPayload = {
  queryGroups: [
    {
      'id': 'f05b0390-f575-11ef-bbaa-4b327ec3a55c',
      'relation': 'And',
      'clause': {
        'column': {
          'id': 0,
          'internalName': 'fields/assignedto/uniquename',
          'displayName': 'Action Owner',
        },
        'operator': {
          'id': 1,
          'operatorInternalName': '<>',
        },
        'values': [],
      },
      'index': 0,
      'queryGroupInfo': [],
    },
  ],
  groupInfo: [],
};

export const filterableAndSelectableColumnsROB: string[] = [
  UATConstants.ArtemisFieldPaths.ID,
  UATConstants.ArtemisFieldPaths.Title,
  UATConstants.ArtemisFieldPaths.ActionOwner,
  UATConstants.ArtemisFieldPaths.ActionCategory,
  UATConstants.ArtemisFieldPaths.State,
  UATConstants.ArtemisFieldPaths.ActionOwnerGroup,
  UATConstants.ArtemisFieldPaths.AssignedTeam,
  UATConstants.ArtemisFieldPaths.AccountableExec,
  UATConstants.ArtemisFieldPaths.Areas,
  UATConstants.ArtemisFieldPaths.BusinessImpact,
  UATConstants.ArtemisFieldPaths.CreatedDate,
  UATConstants.ArtemisFieldPaths.ClosedDate,
  UATConstants.ArtemisFieldPaths.ClosureStatement,
  UATConstants.ArtemisFieldPaths.Contributors,
  UATConstants.ArtemisFieldPaths.DueDate,
  UATConstants.ArtemisFieldPaths.MeetingTypeMCAPS,
  UATConstants.ArtemisFieldPaths.MeetingSubTypeMCAPS,
  UATConstants.ArtemisFieldPaths.ActionPriorityField,
  UATConstants.ArtemisFieldPaths.ProblemDetails,
  UATConstants.ArtemisFieldPaths.Regions,
  UATConstants.ArtemisFieldPaths.RequestedDate,
  UATConstants.ArtemisFieldPaths.Requestors,
  UATConstants.ArtemisFieldPaths.SolutionArea,
  UATConstants.ArtemisFieldPaths.StatusUpdate,
  UATConstants.ArtemisFieldPaths.SubState,
  UATConstants.ArtemisFieldPaths.SubRegions,
  UATConstants.ArtemisFieldPaths.UserChangedBy,
  UATConstants.ArtemisFieldPaths.ChangedDate,
  UATConstants.ArtemisFieldPaths.Tags,
  UATConstants.ArtemisFieldPaths.RevenueImpacted,
  UATConstants.ArtemisFieldPaths.SegmentLists,
  UATConstants.ArtemisFieldPaths.MeetingFiscalYear,
  UATConstants.ArtemisFieldPaths.Quarter,
  UATConstants.ArtemisFieldPaths.MeetingMonth,
  UATConstants.ArtemisFieldPaths.LinkedTechRoB,
];

export const stateDropdownValuesROB: string[] = [
  UATConstants.ArtemisStateDropdownValues.Done,
  UATConstants.ArtemisStateDropdownValues.InProgress,
  UATConstants.ArtemisStateDropdownValues.Removed,
  UATConstants.ArtemisStateDropdownValues.OnHold,
];

export const subStateDropdownValuesROB: string[] = [
  UATConstants.ArtemisSubStateDropdownValues.ActiveActionResolution,
  UATConstants.ArtemisSubStateDropdownValues.AwaitingPrioritization,
  UATConstants.ArtemisSubStateDropdownValues.DecisionNotToPursue,
  UATConstants.ArtemisSubStateDropdownValues.Duplicate,
  UATConstants.ArtemisSubStateDropdownValues.Inactive,
  UATConstants.ArtemisSubStateDropdownValues.New,
  UATConstants.ArtemisSubStateDropdownValues.NoActionRequired,
  UATConstants.ArtemisSubStateDropdownValues.Other,
  UATConstants.ArtemisSubStateDropdownValues.PlanInPlace,
  UATConstants.ArtemisSubStateDropdownValues.Resolved,
  UATConstants.ArtemisSubStateDropdownValues.Resources,
  UATConstants.ArtemisSubStateDropdownValues.Timing,
  UATConstants.ArtemisSubStateDropdownValues.Unresolved,
  UATConstants.ArtemisSubStateDropdownValues.Closed,
];

export const solutionAreaDropdownValuesROB: string[] = [
  UATConstants.ArtemisSolutionAreaDropdownValues.Azure,
  UATConstants.ArtemisSolutionAreaDropdownValues.BusinessApplications,
  UATConstants.ArtemisSolutionAreaDropdownValues.ModernWork,
  UATConstants.ArtemisSolutionAreaDropdownValues.Other,
  UATConstants.ArtemisSolutionAreaDropdownValues.Security,
  UATConstants.ArtemisSolutionAreaDropdownValues.UnifiedSupport,
];

export const meetingTypeDropdownValuesROB: string[] = [
  UATConstants.ArtemisMeetingTypeDropdownValues.SBR,
  UATConstants.ArtemisMeetingTypeDropdownValues.VSU,
  UATConstants.ArtemisMeetingTypeDropdownValues.GlobalReviews,
  UATConstants.ArtemisMeetingTypeDropdownValues.MCAPSPrioritiesRoB,
  UATConstants.ArtemisMeetingTypeDropdownValues.MarketingRoB,
  UATConstants.ArtemisMeetingTypeDropdownValues.AsiaInRegionMeetingRoB,
];

export const meetingSubTypeDropdownValuesROB: string[] = [
  UATConstants.ArtemisMeetingSubTypeDropdownValues.AsiaCoreLTWeeklyStandUpMeeting,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.AsiaMCAPsPrioritiesRoBInRegion,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.Azure,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.BusinessApps,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.CSADeepDive,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.GlobalEnterprisePartnerReview,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.GlobalMarketingReview,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.GPS,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.IndustrySolutionsDelivery,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.IndustrySolutionsDelivery,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.InOUMeeting,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.MCAPSRegionMeeting,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.ModernWork,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.MSUnified,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.OthersIntakeTriageProcess,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.PublicSector,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.RegionalCMOMarketingReviews,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.RegionOUMeeting,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.Security,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.SMC,
  UATConstants.ArtemisMeetingSubTypeDropdownValues.UnifiedSupport,
];

export const fyDropdownValuesROB: string[] = ['FY2025', 'FY2024'];

export const meetingMonthDropdownValuesROB: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const ManageViewSupportedOperations: Record<string, ISupportedOperation> = {
  Equals: {
    ReferenceName: 'SupportedOperations.Equals',
    Name: '=',
  },
  NotEquals: {
    ReferenceName: 'SupportedOperations.NotEquals',
    Name: '<>',
  },
  GreaterThan: {
    ReferenceName: 'SupportedOperations.GreaterThan',
    Name: '>',
  },
  LessThan: {
    ReferenceName: 'SupportedOperations.LessThan',
    Name: '<',
  },
  GreaterThanEquals: {
    ReferenceName: 'SupportedOperations.GreaterThanEquals',
    Name: '>=',
  },
  LessThanEquals: {
    ReferenceName: 'SupportedOperations.LessThanEquals',
    Name: '<=',
  },
  Contains: {
    ReferenceName: 'SupportedOperations.Contains',
    Name: 'Contains',
  },
  NotContains: {
    ReferenceName: 'SupportedOperations.NotContains',
    Name: 'Does Not Contain',
  },
  ContainsWords: {
    ReferenceName: 'SupportedOperations.ContainsWords',
    Name: 'Contains Words',
  },
  NotContainsWords: {
    ReferenceName: 'SupportedOperations.NotContainsWords',
    Name: 'Does Not Contain Words',
  },
  In: {
    ReferenceName: 'SupportedOperations.In',
    Name: 'In',
  },
  NotIn: {
    ReferenceName: 'SupportedOperations.NotIn',
    Name: 'Not In',
  },
  InGroup: {
    ReferenceName: 'SupportedOperations.InGroup',
    Name: 'In Group',
  },
  NotInGroup: {
    ReferenceName: 'SupportedOperations.NotInGroup',
    Name: 'Not In Group',
  },
  Ever: {
    ReferenceName: 'SupportedOperations.Ever',
    Name: 'Was Ever',
  },
  EqualsField: {
    ReferenceName: 'SupportedOperations.EqualsField',
    Name: '= [Field]',
  },
  NotEqualsField: {
    ReferenceName: 'SupportedOperations.NotEqualsField',
    Name: '<> [Field]',
  },
  GreaterThanField: {
    ReferenceName: 'SupportedOperations.GreaterThanField',
    Name: '> [Field]',
  },
  LessThanField: {
    ReferenceName: 'SupportedOperations.LessThanField',
    Name: '< [Field]',
  },
  GreaterThanEqualsField: {
    ReferenceName: 'SupportedOperations.GreaterThanEqualsField',
    Name: '>= [Field]',
  },
  LessThanEqualsField: {
    ReferenceName: 'SupportedOperations.LessThanEqualsField',
    Name: '<= [Field]',
  },
};


export const isArtemisViewIdPresent = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(ManageViewConstants.UrlQueryParameters.ViewIdArtemis);
}
// Generated by GitHub Copilot | Updated on: 2026-04-16 | 1 lines modified | Changed Competitor to Custom.CompetitorNameDD
// Generated by GitHub Copilot | Updated on: 2026-06-03 | 1 lines modified | Added Field ECIF display name mapping
// Generated by GitHub Copilot | Updated on: 2026-06-25 | 7 lines modified | US 138301: Add Related Tech RoB ID(s) to default columns and selectable columns for RoB
// Generated by GitHub Copilot | Updated on: 2026-07-09 | 1 line added | Added AOAIRequestUrgency ManageviewField (Custom.RequestUrgency) so Manage View filter recognizes the field (WI #138509)
// Generated by GitHub Copilot | Updated on: 2026-07-13 | 1 line added | Added AOAIUOM ManageviewField (Custom.UnitofMeasurement) so Manage View filter recognizes the field (WI #138593)
// Generated by GitHub Copilot | Updated on: 2026-09-01 | 4 lines added | Added Artemis field paths for Partner Investments survey question filters
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 1 line added | Explain blank-only Compete equality
// Generated by GitHub Copilot | Updated on: 2026-10-14 | 1 line removed | Remove obsolete Compete equality message
